<div class="view-notes-dialog">
  <div class="view-notes-header">
    <span>Note</span>
  </div>
  <div class="view-notes-content">
    @if (noteText) {
      <div class="note-item">
        <p>{{ noteText }}</p>
      </div>
    } @else {
      <div class="no-notes">
        <p>No notes available</p>
      </div>
    }
  </div>
  <div class="view-notes-actions">
    <owc-button color="primary" (click)="onClose()">
      Close
    </owc-button>
  </div>
</div>
